var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.182,
    height: 26.183,
    viewBox: "0 0 26.182 26.183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 26.182,
    height: 26.182,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2329",
    "data-name": "Groupe 2329",
    transform: "translate(-881.318 -9125.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_194",
    "data-name": "Groupe 194",
    transform: "translate(881.318 9125.911)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_15",
    "data-name": "Groupe 15",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M13.1,0A13.091,13.091,0,1,1,0,13.082,13.1,13.1,0,0,1,13.1,0m.711,12.047c0-.4-.016-.667,0-.932s-.07-.355-.342-.348c-.681.018-1.363.012-2.045,0-.242,0-.37.035-.369.329q.015,4.269,0,8.538c0,.275.093.349.353.343.7-.014,1.4-.025,2.1,0,.347.014.417-.1.414-.427-.017-1.4-.008-2.795-.006-4.192a3.384,3.384,0,0,1,.26-1.446,1.518,1.518,0,0,1,1.705-.832,1.22,1.22,0,0,1,1.127,1.075,2.6,2.6,0,0,1,.084.6c.015,1.585.031,3.17.022,4.754,0,.344.072.481.445.464.663-.03,1.329-.025,1.993,0,.324.011.434-.069.43-.415-.021-1.636-.011-3.272-.013-4.908a7.122,7.122,0,0,0-.236-1.972,2.608,2.608,0,0,0-1.542-1.85,3.557,3.557,0,0,0-4.379,1.21M6.434,15.374c0,1.413.008,2.827-.006,4.24,0,.286.074.378.366.369.715-.021,1.43-.015,2.145,0,.248,0,.361-.045.36-.332q-.015-4.265,0-8.531c0-.268-.08-.355-.348-.349-.7.015-1.4.021-2.094,0-.325-.01-.437.069-.432.419.022,1.4.009,2.792.009,4.189M7.849,9.52A1.655,1.655,0,1,0,6.187,7.879,1.66,1.66,0,0,0,7.849,9.52",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.a6ee484111e3c99eea99ef474fdf6902.svg";
export { ForwardRef as ReactComponent };